import { SupportedRegions } from "@nova/constants"
import { get } from "nodash"

export const isMac = (): boolean => {
    if (typeof navigator === "undefined") return false

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- can install user-agent-data-types, or just do this
    const uaData = (navigator as any).userAgentData
    if (uaData?.platform?.toLowerCase().includes("mac")) {
        return true
    }

    const ua = navigator.userAgent.toLowerCase()
    return ua.includes("macintosh") || ua.includes("mac os")
}

export const getRegion = () => {
    let region = SupportedRegions.Canada
    if ((self as Window & typeof globalThis & { region?: SupportedRegions }).region)
        region = (self as Window & typeof globalThis & { region: SupportedRegions }).region
    else {
        try {
            const defaultRegion = JSON.stringify(SupportedRegions.Canada)
            region = JSON.parse(sessionStorage.getItem("region") || defaultRegion)
        } catch {}
    }
    return region
}

export const getBrowserDetector = () => {
    const winNav = window.navigator

    const isChromium = get(window, "chrome")
    const isOpera = typeof get(window, "opr") !== "undefined"
    const isFirefox = winNav.userAgent.indexOf("Firefox") > -1
    const isEdge = winNav.userAgent.indexOf("Edg") > -1
    const isIOSChrome = winNav.userAgent.match("CriOS")
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

    return {
        isChrome: () => isChromium || isIOSChrome,
        isFirefox: () => isFirefox,
        isSafari: () => isSafari,
        isEdge: () => isEdge,
        isOpera: () => isOpera,
        isUnknown: () =>
            !(isChromium || !isIOSChrome || isFirefox || isSafari || isEdge || isOpera),
    }
}

export const isFormFieldFocused = (e: KeyboardEvent) =>
    e.target instanceof HTMLElement &&
    (["INPUT", "TEXTAREA", "SELECT"].includes(e.target.tagName) || e.target.isContentEditable)
